import React from "react";
import style from "./index.module.scss";
import { Checkbox, Radio } from "antd";
import {
    BaseQuestionType,
    BaseQuestionTypeMap,
    viewPaperListItem
} from "service/question";

interface TopicReviewProps {
    data: viewPaperListItem;
    index: number | string;
}

export default function TopicReview({ data, index }: TopicReviewProps) {
    const type: BaseQuestionType = data.queTypeId;

    return (
        <div className={style.root}>
            <div className={style.info}>
                <em>{index}.</em>
                {data.typeName ? data.typeName : BaseQuestionTypeMap[type]}
            </div>

            <div className={style.trunk}>
                <div
                    className={style.title}
                    dangerouslySetInnerHTML={{ __html: data.contentText }}
                />
            </div>

            <div className={style.options}>
                {/* 单选项 */}
                {data.queTypeId === BaseQuestionType.SingleChoice && (
                    <Radio.Group disabled>
                        {data.options.map(item => (
                            <Radio
                                className={style.option}
                                value={item.id}
                                key={item.id}
                                checked={String(item.id) === data.stuAns}>
                                <div className={style.index}>
                                    {item.serialNum}.
                                </div>
                                <div
                                    className={style.optionInner}
                                    dangerouslySetInnerHTML={{
                                        __html: item.description
                                    }}
                                />
                            </Radio>
                        ))}
                    </Radio.Group>
                )}

                {/* 多选项 */}
                {data.queTypeId === BaseQuestionType.MultipleChoice &&
                    data.options.map(item => (
                        <Checkbox
                            disabled
                            className={style.option}
                            value={item.id}
                            key={item.id}
                            checked={data.stuAns?.includes(item.id + "")}>
                            <div className={style.index}>{item.serialNum}.</div>
                            <div
                                className={style.optionInner}
                                dangerouslySetInnerHTML={{
                                    __html: item.description
                                }}
                            />
                        </Checkbox>
                    ))}
            </div>

            {data.queTypeId === BaseQuestionType.Subjective && (
                <div>
                    <div
                        className={style.answer}
                        dangerouslySetInnerHTML={{ __html: data.stuAns }}
                    />
                </div>
            )}
        </div>
    );
}
